import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `LayoutGrid` — layout-grid icon.
 * Aria label:    layout-grid
 * Family:        navigation
 * Related:       panel-right, layout-list, layout-dashboard, external-link
 * Canonical use: layout-grid glyph in navigation UI surfaces.
 * Audited 2026-09-20 — no-op (5/5 criteria pass). Layout grid.
 *
 */
export const LayoutGrid = forwardRef(function LayoutGrid(props, ref) {
    return (_jsxs(IconBase, { ref: ref, ...props, children: [_jsx("path", { d: "M3 3 h7 v7 H3 z" }), _jsx("path", { d: "M14 3 h7 v7 h-7 z" }), _jsx("path", { d: "M3 14 h7 v7 H3 z" }), _jsx("path", { d: "M14 14 h7 v7 h-7 z" })] }));
});
//# sourceMappingURL=layout-grid.js.map